export const ESTADOS = {
  pendiente: { label: "Pendiente", cls: "border-amber-500/50 text-amber-600 dark:text-amber-400" },
  aceptada: { label: "Aceptada", cls: "border-emerald-500/50 text-emerald-600 dark:text-emerald-400" },
  presentada: { label: "Presentada", cls: "border-emerald-500/50 text-emerald-600 dark:text-emerald-400" },
  rechazada: { label: "Rechazada", cls: "border-red-500/50 text-red-600 dark:text-red-400" },
  no_disponible: { label: "No disponible", cls: "c-line c-muted" },
  vencida: { label: "Vencida", cls: "c-line c-muted" },
};

export const fmtDay = (iso) => (iso ? new Date(iso).toLocaleDateString("es-MX", { day: "numeric", month: "short" }) : "");

export const venceText = (iso) => {
  const days = Math.ceil((new Date(iso) - new Date()) / 86400000);
  return days <= 0 ? "Vence hoy" : `Vence en ${days} día${days === 1 ? "" : "s"}`;
};

export const waLink = (phone, text) => (phone ? `https://wa.me/${phone.replace(/^\+/, "")}?text=${encodeURIComponent(text)}` : null);
